import { Fragment } from "react";
import { cn } from "@/libs/utils";
import { Text } from "src/common/Text";
import { useTrans } from "src/utils/useTrans";

export default function UList({
  className = "",
  list,
}: {
  className?: string;
  list: string[];
}) {
  const { t } = useTrans(["support"]);
  return (
    <Fragment>
      <div className={cn(className, "flex flex-col gap-y-0.5")}>
        {list.map((item, index) => {
          return (
            <div className="flex w-full gap-x-2.5 px-2.5" key={index}>
              <div className="mt-[10px] h-0.5 min-h-[2px] w-0.5 min-w-[2px] rounded-full bg-black" />
              <Text
                className={"whitespace-normal text-base font-400"}
                text={t(item)}
              />
            </div>
          );
        })}
      </div>
    </Fragment>
  );
}
